/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Quick_Scan_EmptyInputs */

const vi_warehouse_quick_scan_empty = /** @type {(inputs: Warehouse_Quick_Scan_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa nhập sản phẩm nào — quét để nhập kho ngay.`)
};

/**

* @param {Warehouse_Quick_Scan_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_quick_scan_empty = /** @type {((inputs?: Warehouse_Quick_Scan_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Quick_Scan_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_quick_scan_empty(inputs)
});